import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-793fddae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container my-5"
}
const _hoisted_2 = { class: "left-pane" }
const _hoisted_3 = {
  autoplay: "",
  loop: "",
  muted: "",
  playsinline: "",
  class: "animation-video"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "right-pane d-none d-sm-flex" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "p-2" }
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = { class: "d-flex flex-row w-100 pt-2 justify-content-between" }
const _hoisted_15 = { class: "price-text" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "d-flex flex-row pt-1 justify-content-end" }
const _hoisted_18 = {
  key: 0,
  class: "wallet-text-small"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "mb-0" }
const _hoisted_21 = { class: "my-3" }
const _hoisted_22 = { class: "text-bold mb-1" }
const _hoisted_23 = { class: "my-3" }
const _hoisted_24 = { class: "text-bold mb-1" }
const _hoisted_25 = { class: "duration" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-2" }, null, -1))
const _hoisted_27 = {
  key: 0,
  class: "text-primary autodesk-price"
}
const _hoisted_28 = { class: "price-label" }
const _hoisted_29 = {
  key: 0,
  class: "wallet-card-container",
  style: {'background-image': `url('/Static/images/stars-background.jpg')`}
}
const _hoisted_30 = { class: "wallet-card-extended" }
const _hoisted_31 = ["alt"]
const _hoisted_32 = { class: "wallet-text" }
const _hoisted_33 = {
  key: 1,
  class: "wallet-amount"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-1 mt-2 wallet-card-line" }, null, -1))
const _hoisted_35 = ["href"]
const _hoisted_36 = { class: "d-flex flex-column mx-1" }
const _hoisted_37 = { class: "title" }
const _hoisted_38 = { class: "content" }
const _hoisted_39 = { class: "mr-1" }
const _hoisted_40 = { class: "d-flex flex-column mx-1" }
const _hoisted_41 = { class: "title" }
const _hoisted_42 = { class: "content" }
const _hoisted_43 = { class: "mr-1" }
const _hoisted_44 = { class: "mr-1" }
const _hoisted_45 = { class: "mr-1" }
const _hoisted_46 = {
  key: 0,
  class: "mb-0 text-bold"
}
const _hoisted_47 = ["title", "onClick"]
const _hoisted_48 = {
  key: 1,
  class: "mb-0 text-bold"
}
const _hoisted_49 = { class: "text-bold" }
const _hoisted_50 = { class: "mr-1" }
const _hoisted_51 = {
  key: 0,
  class: "text-success"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check-circle mr-1" }, null, -1))
const _hoisted_53 = ["href"]
const _hoisted_54 = { class: "" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = ["innerHTML"]
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = ["src", "title"]
const _hoisted_60 = { class: "text-muted lead text-right" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { class: "lead mt-2" }
const _hoisted_63 = { class: "align-self-center mr-1" }
const _hoisted_64 = ["alt", "title"]
const _hoisted_65 = { class: "d-flex flex-column align-items-start flex-1 text-left" }
const _hoisted_66 = { class: "mb-0 font-weight-bold" }
const _hoisted_67 = { class: "mb-0 text-muted font-weight-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductPageContentSection = _resolveComponent("ProductPageContentSection")!
  const _component_BaseProductOverviewItemCard = _resolveComponent("BaseProductOverviewItemCard")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_ProductConfigurationOption = _resolveComponent("ProductConfigurationOption")!
  const _component_Message = _resolveComponent("Message")!
  const _component_ProductPageSummary = _resolveComponent("ProductPageSummary")!
  const _component_ProductLayout = _resolveComponent("ProductLayout")!
  const _component_ProductConfigurationFlexLicense = _resolveComponent("ProductConfigurationFlexLicense")!
  const _component_ProductConfigurationStep = _resolveComponent("ProductConfigurationStep")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_ProductConfiguration = _resolveComponent("ProductConfiguration")!
  const _component_ProductTabs = _resolveComponent("ProductTabs")!
  const _component_PriceSummary = _resolveComponent("PriceSummary")!
  const _component_ProductConfigurationSummaryItem = _resolveComponent("ProductConfigurationSummaryItem")!
  const _component_ProductConfigurationSummary = _resolveComponent("ProductConfigurationSummary")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_WalletMessage = _resolveComponent("WalletMessage")!
  const _component_ProductAddedModal = _resolveComponent("ProductAddedModal")!
  const _component_PartnerInfoModal = _resolveComponent("PartnerInfoModal")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAutodeskProduct)
      ? (_openBlock(), _createBlock(_component_ProductLayout, {
          key: 0,
          modelValue: _ctx.showSideBar,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showSideBar) = $event)),
          "help-block": _ctx.selectedHelpBlock,
          vm: _ctx.vm
        }, {
          tabs: _withCtx(() => [
            (_ctx.vm.autodeskInfoBlock?.isVisible && _ctx.vm.autodeskInfoBlock?.video && _ctx.vm.autodeskInfoBlock?.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("video", _hoisted_3, [
                      _createElementVNode("source", {
                        src: _ctx.vm.autodeskInfoBlock.video,
                        type: "video/mp4"
                      }, null, 8, _hoisted_4),
                      _createTextVNode(" Your browser does not support the video tag. ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.vm.autodeskInfoBlock.title), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.vm.autodeskInfoBlock.text), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.hasTab('tabInfo'))
              ? (_openBlock(), _createBlock(_component_ProductPageContentSection, { key: 1 }, {
                  default: _withCtx(() => [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.vm.productInfoTabTitle || _ctx.$t("product.tabProductInfoTitle")) + " " + _toDisplayString(_ctx.vm.name), 1),
                    _createElementVNode("div", {
                      class: "rte",
                      innerHTML: _ctx.vm.productInfoTab
                    }, null, 8, _hoisted_6)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.$slots.blocks)
              ? (_openBlock(), _createBlock(_component_ProductPageContentSection, {
                  key: 2,
                  type: "content"
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "blocks", {}, undefined, true)
                  ]),
                  _: 3
                }))
              : _createCommentVNode("", true),
            (_ctx.vm.relatedUpSellProducts?.length)
              ? (_openBlock(), _createBlock(_component_ProductPageContentSection, {
                  key: 3,
                  type: "upsell"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t("product.titleUpSell")), 1),
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.relatedUpSellProducts, (product) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: product,
                          class: "col-md-6 mb-2"
                        }, [
                          _createVNode(_component_BaseProductOverviewItemCard, {
                            "is-cross-sell": "",
                            vm: product
                          }, null, 8, ["vm"])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.vm.autodeskSupportBlock?.isVisible && _ctx.vm.autodeskSupportBlock?.items?.length)
              ? (_openBlock(), _createBlock(_component_ProductPageContentSection, {
                  key: 4,
                  type: "content"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.vm.autodeskSupportBlock.title), 1),
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.autodeskSupportBlock.items, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item,
                          class: "col-md-6 mb-2"
                        }, [
                          _createVNode(_component_Card, { class: "support-card" }, {
                            header: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, {
                                class: "support-icon mt-3",
                                icon: item.icon,
                                size: "2x"
                              }, null, 8, ["icon"])
                            ]),
                            title: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.title), 1)
                            ]),
                            content: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.text), 1)
                            ]),
                            footer: _withCtx(() => [
                              _createVNode(_component_Button, {
                                class: "search-button w-100 p-button-raised",
                                label: item.buttonText,
                                title: item.buttonText,
                                url: item.buttonLink?.url
                              }, null, 8, ["label", "title", "url"])
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          summary: _withCtx(() => [
            _createVNode(_component_ProductPageSummary, {
              "can-submit": !_ctx.submitted && _ctx.validateProductConfiguration() && _ctx.vm.availableInCurrentMarket,
              "is-in-edit-mode": _ctx.isInEditMode,
              "is-autodesk-product": _ctx.isAutodeskProduct,
              "is-product-available": _ctx.vm.viewModelIsValid && !_ctx.isFlexLicense,
              "max-amount": _ctx.productStore.selectedVariation?.maxQuantity,
              "min-amount": _ctx.productStore.selectedVariation?.minQuantity,
              "offer-request-form-url": _ctx.vm.productGuid,
              "show-amount-input": "",
              "total-price": _ctx.priceSummary?.totalPrice,
              value: _ctx.productStore?.selectedAmount,
              "variation-guid": _ctx.productStore.selectedVariation?.guid,
              "variation-id": _ctx.productStore.selectedVariation?.id,
              onAddToCart: _ctx.addProductToCart,
              onAmountChanged: _ctx.onSelectedAmountChanged,
              onRequestAutodeskQuote: _ctx.onRequestAutodeskQuote
            }, {
              priceSummary: _withCtx(() => [
                (_ctx.isSmallScreen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              (!_ctx.vm.isValueBasedProduct)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.formatCurrency(_ctx.priceSummary.basePrice)), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_InputNumber, {
                              modelValue: _ctx.selectedAmount,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAmount) = $event)),
                              class: "",
                              "decrement-button-class": "p-button-outlined",
                              "increment-button-class": "p-button-outlined",
                              max: _ctx.maxAmount,
                              min: _ctx.minAmount,
                              "show-buttons": "",
                              style: _normalizeStyle([{"width":"clamp(125px, 25%, 175px)","margin-top":"-8px"}, [_ctx.isSmallScreen ? { 'height': 44 + 'px' } : { 'height': 59 + 'px' }]]),
                              "use-grouping": false,
                              onInput: _ctx.amountChanged
                            }, null, 8, ["modelValue", "max", "min", "style", "onInput"])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productStore.availableDurations, (option, index) => {
                              return (_openBlock(), _createBlock(_component_ProductConfigurationOption, {
                                class: "duration",
                                key: index,
                                disabled: _ctx.isBusy,
                                "is-selected": option.value === _ctx.productStore.selectedDuration,
                                option: option,
                                onOptionSelected: ($event: any) => (_ctx.onDurationSelected(option.value))
                              }, null, 8, ["disabled", "is-selected", "option", "onOptionSelected"]))
                            }), 128))
                          ]),
                          (_ctx.vm.autodeskLoyaltyCashbackBlock?.isVisible && parseInt(_ctx.productStore.walletAmount) !== 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t('quotation.product.wallet.label')) + " " + _toDisplayString(_ctx.formatCurrency(_ctx.productStore.walletAmount)), 1))
                            : _createCommentVNode("", true),
                          (_ctx.isAutodeskProduct)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 1,
                                class: "p-button-success p-button-lg p-button-raised p-button-arrow w-100 px-1 my-1",
                                label: _ctx.$t(`product.button.quote`),
                                disabled: _ctx.submitted || !_ctx.validateProductConfiguration() || !_ctx.vm.availableInCurrentMarket,
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onRequestAutodeskQuote()))
                              }, null, 8, ["label", "disabled"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.vm.brand), 1),
                      _createElementVNode("h1", null, _toDisplayString(_ctx.formatProductName(_ctx.vm.name, _ctx.vm.brand)), 1),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("common.productSummary.amount")), 1),
                        _createVNode(_component_InputNumber, {
                          modelValue: _ctx.selectedAmount,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedAmount) = $event)),
                          class: "mr-2",
                          "decrement-button-class": "p-button-outlined",
                          "increment-button-class": "p-button-outlined",
                          max: _ctx.maxAmount,
                          min: _ctx.minAmount,
                          "show-buttons": "",
                          style: {"width":"clamp(125px, 25%, 175px)","height":"59px","margin-top":"-8px"},
                          "use-grouping": false,
                          onInput: _ctx.amountChanged
                        }, null, 8, ["modelValue", "max", "min", "onInput"])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("common.productSummary.duration")), 1),
                        _createElementVNode("div", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productStore.availableDurations, (option, index) => {
                            return (_openBlock(), _createBlock(_component_ProductConfigurationOption, {
                              class: "duration",
                              key: index,
                              disabled: _ctx.isBusy,
                              "is-selected": option.value === _ctx.productStore.selectedDuration,
                              option: option,
                              onOptionSelected: ($event: any) => (_ctx.onDurationSelected(option.value))
                            }, null, 8, ["disabled", "is-selected", "option", "onOptionSelected"]))
                          }), 128))
                        ])
                      ]),
                      _hoisted_26,
                      (_ctx.vm.basePrice)
                        ? (_openBlock(), _createElementBlock("h4", _hoisted_27, [
                            _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("common.priceSummary.basePrice")), 1),
                            _createElementVNode("span", null, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.formatCurrency(_ctx.priceSummary.basePrice)), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ]),
              configurationSummary: _withCtx(() => []),
              validationMessage: _withCtx(() => [
                (_ctx.validationErrors.length && _ctx.submitted)
                  ? (_openBlock(), _createBlock(_component_Message, {
                      key: 0,
                      closable: false,
                      severity: "warn",
                      style: {"cursor":"pointer"},
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scrollToFirstValidationError()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$tc("common.productSummary.msgValidationErrors", _ctx.validationErrors.length)), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              walletMessage: _withCtx(() => [
                ((_ctx.vm.autodeskLoyaltyCashbackBlock?.isVisible && parseInt(_ctx.productStore.walletAmount) !== 0) || _ctx.vm.isValueBasedProduct)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        (_ctx.vm.autodeskLoyaltyCashbackBlock?.icon)
                          ? _withDirectives((_openBlock(), _createElementBlock("img", {
                              key: 0,
                              alt: _ctx.vm.autodeskLoyaltyCashbackBlock?.icon?.alt,
                              class: "wallet-icon"
                            }, null, 8, _hoisted_31)), [
                              [_directive_lazy, _ctx.vm.autodeskLoyaltyCashbackBlock.icon?.url]
                            ])
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.vm.autodeskLoyaltyCashbackBlock?.text), 1),
                        (!_ctx.vm.isValueBasedProduct)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.formatCurrency(_ctx.productStore.walletAmount)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_34,
                      _createElementVNode("a", {
                        href: _ctx.vm.autodeskLoyaltyCashbackBlock?.link?.url,
                        class: "wallet-card-link"
                      }, _toDisplayString(_ctx.vm.autodeskLoyaltyCashbackBlock?.link?.text), 9, _hoisted_35)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["can-submit", "is-in-edit-mode", "is-autodesk-product", "is-product-available", "max-amount", "min-amount", "offer-request-form-url", "total-price", "value", "variation-guid", "variation-id", "onAddToCart", "onAmountChanged", "onRequestAutodeskQuote"])
          ]),
          _: 3
        }, 8, ["modelValue", "help-block", "vm"]))
      : _createCommentVNode("", true),
    (!_ctx.isAutodeskProduct)
      ? (_openBlock(), _createBlock(_component_ProductLayout, {
          key: 1,
          modelValue: _ctx.showSideBar,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.showSideBar) = $event)),
          "help-block": _ctx.selectedHelpBlock,
          vm: _ctx.vm
        }, {
          tabs: _withCtx(() => [
            _createVNode(_component_ProductTabs, { items: _ctx.productTabs }, {
              tabConfiguration: _withCtx(() => [
                _createVNode(_component_ProductPageContentSection, null, {
                  default: _withCtx(() => [
                    (_ctx.vm.advisorInfoPageUrl && _ctx.vm.brand?.toLowerCase() === 'autodesk')
                      ? (_openBlock(), _createBlock(_component_Message, {
                          key: 0,
                          class: "advice-banner",
                          closable: false,
                          severity: "info"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("digitalAdvisor.banner.titleDigitalAdvisor")), 1),
                              _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t("digitalAdvisor.banner.digitalAdvisorSummary")), 1)
                            ]),
                            _createVNode(_component_Button, {
                              class: "advice-button p-button-success p-button-primary mx-1",
                              label: _ctx.$t('digitalAdvisor.button.adviceMe'),
                              onClick: _cache[5] || (_cache[5] = ($event: any) => {
									_ctx.openUrl(_ctx.vm.advisorInfoPageUrl);
									$event.target.disabled = true;
								})
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.vm.viewModelIsValid)
                      ? (_openBlock(), _createBlock(_component_ProductConfiguration, { key: 1 }, {
                          default: _withCtx(() => [
                            (_ctx.productStore.availableLicenseModels?.length > 1)
                              ? (_openBlock(), _createBlock(_component_ProductConfigurationStep, {
                                  key: 0,
                                  id: "step-type"
                                }, {
                                  header: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("product.lblChooseLicenceModel")), 1),
                                    (_ctx.vm.helpBlockLicenseType)
                                      ? (_openBlock(), _createBlock(_component_Button, {
                                          key: 0,
                                          class: "header-explanation-text text-underline py-0 p-button-text p-button-secondary text-underline",
                                          label: _ctx.vm.helpBlockLicenseType?.linkText,
                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showHelpSideBar(_ctx.vm.helpBlockLicenseType)))
                                        }, null, 8, ["label"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  error: _withCtx(() => [
                                    (
											!_ctx.productValidation.get(_ctx.productValidationEnum.ValidContract) &&
											_ctx.submitted
										)
                                      ? (_openBlock(), _createBlock(_component_Message, {
                                          key: 0,
                                          id: `validation-msg-${_ctx.productValidationEnum.ValidContract}`,
                                          closable: false,
                                          severity: "error"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("product.message.atleastOneAsset")), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["id"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  options: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productStore.availableLicenseModels, (option, index) => {
                                      return (_openBlock(), _createBlock(_component_ProductConfigurationOption, {
                                        key: index,
                                        disabled: _ctx.isBusy,
                                        "is-selected": option.value === _ctx.productStore.selectedLicenseModel,
                                        option: option,
                                        onOptionSelected: ($event: any) => (_ctx.onLicenseModelSelected(option.value))
                                      }, null, 8, ["disabled", "is-selected", "option", "onOptionSelected"]))
                                    }), 128)),
                                    (_ctx.isFlexLicense)
                                      ? (_openBlock(), _createBlock(_component_ProductConfigurationFlexLicense, {
                                          key: 0,
                                          "product-name": _ctx.vm.name,
                                          "product-usage-advice": _ctx.productStore.productUsageAdvice,
                                          onSelectSubscription: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onLicenseModelSelected(0)))
                                        }, null, 8, ["product-name", "product-usage-advice"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_Message, {
                                      class: "advice-banner",
                                      closable: false,
                                      severity: "info"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_40, [
                                          _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("digitalAdvisor.banner.titleDigitalAdvisor")), 1),
                                          _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t("digitalAdvisor.banner.digitalAdvisorSummary")), 1)
                                        ]),
                                        _createVNode(_component_Button, {
                                          class: "advice-button p-button-success p-button-raised p-button-primary mx-1",
                                          label: _ctx.$t('digitalAdvisor.button.adviceMe'),
                                          onClick: _cache[8] || (_cache[8] = ($event: any) => {
												_ctx.openUrl(_ctx.vm.advisorInfoPageUrl);
												$event.target.disabled = true;
											})
                                        }, null, 8, ["label"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.productStore.availableLicenseClasses?.length > 0 && !_ctx.isFlexLicense)
                              ? (_openBlock(), _createBlock(_component_ProductConfigurationStep, {
                                  key: 1,
                                  id: "step-type"
                                }, {
                                  header: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("product.lblChooseLicenceType")), 1),
                                    (_ctx.vm.helpBlockLicenseType)
                                      ? (_openBlock(), _createBlock(_component_Button, {
                                          key: 0,
                                          class: "header-explanation-text text-underline py-0 p-button-text p-button-secondary text-underline",
                                          label: _ctx.vm.helpBlockLicenseType?.linkText,
                                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showHelpSideBar(_ctx.vm.helpBlockLicenseType)))
                                        }, null, 8, ["label"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  error: _withCtx(() => [
                                    (
											!_ctx.productValidation.get(_ctx.productValidationEnum.ValidContract) &&
											_ctx.submitted
										)
                                      ? (_openBlock(), _createBlock(_component_Message, {
                                          key: 0,
                                          id: `validation-msg-${_ctx.productValidationEnum.ValidContract}`,
                                          closable: false,
                                          severity: "error"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("product.message.atleastOneAsset")), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["id"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  options: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productStore.availableLicenseClasses, (option, index) => {
                                      return (_openBlock(), _createBlock(_component_ProductConfigurationOption, {
                                        key: index,
                                        disabled: _ctx.isBusy,
                                        "is-selected": option.value === _ctx.productStore.selectedLicenseClass,
                                        option: option,
                                        onOptionSelected: ($event: any) => (_ctx.onLicenseClassSelected(option.value))
                                      }, null, 8, ["disabled", "is-selected", "option", "onOptionSelected"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.productStore.availableLicenseSizes?.length > 0 && !_ctx.isFlexLicense)
                              ? (_openBlock(), _createBlock(_component_ProductConfigurationStep, {
                                  key: 2,
                                  id: "step-size"
                                }, {
                                  header: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.vm.unitSelectionTitle || _ctx.$t("product.lblChooseLicenceSize")), 1),
                                    (_ctx.vm.helpBlockProductSize)
                                      ? (_openBlock(), _createBlock(_component_Button, {
                                          key: 0,
                                          class: "header-explanation-text text-underline py-0 p-button-text p-button-secondary",
                                          label: _ctx.vm.helpBlockProductSize?.linkText,
                                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showHelpSideBar(_ctx.vm.helpBlockProductSize)))
                                        }, null, 8, ["label"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  error: _withCtx(() => [
                                    (
											!_ctx.productValidation.get(_ctx.productValidationEnum.ValidContract) &&
											_ctx.submitted
										)
                                      ? (_openBlock(), _createBlock(_component_Message, {
                                          key: 0,
                                          id: `validation-msg-${_ctx.productValidationEnum.ValidContract}`,
                                          closable: false,
                                          severity: "error"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("product.message.atleastOneAsset")), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["id"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  options: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productStore.availableLicenseSizes, (option, index) => {
                                      return (_openBlock(), _createBlock(_component_ProductConfigurationOption, {
                                        key: index,
                                        disabled: _ctx.isBusy,
                                        "is-selected": option.value === _ctx.productStore.selectedLicenseSize,
                                        option: option,
                                        onOptionSelected: ($event: any) => (_ctx.onLicenseSizeSelected(option.value))
                                      }, null, 8, ["disabled", "is-selected", "option", "onOptionSelected"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (
									_ctx.productStore.canAddToContract &&
									_ctx.productStore.isAddingToContract &&
									!_ctx.isFlexLicense
								)
                              ? (_openBlock(), _createBlock(_component_ProductConfigurationStep, {
                                  key: 3,
                                  id: "step-contract"
                                }, {
                                  header: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t("product.lblChooseContract")), 1),
                                    (_ctx.vm.helpBlockContract)
                                      ? (_openBlock(), _createBlock(_component_Button, {
                                          key: 0,
                                          class: "header-explanation-text text-underline py-0 p-button-text p-button-secondary",
                                          label: _ctx.vm.helpBlockContract?.linkText,
                                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showHelpSideBar(_ctx.vm.helpBlockContract)))
                                        }, null, 8, ["label"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  default: _withCtx(() => [
                                    (_ctx.isSpinnerVisible('contractTable'))
                                      ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
                                          key: 0,
                                          "animation-duration": ".75s",
                                          class: "d-block mr-auto ml-0",
                                          "stroke-width": "3"
                                        }))
                                      : (_openBlock(), _createBlock(_component_DataTable, {
                                          key: 1,
                                          selection: _ctx.productStore.selectedContract,
                                          "onUpdate:selection": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.productStore.selectedContract) = $event)),
                                          "auto-layout": "",
                                          "data-key": "contractNumber",
                                          "selection-mode": "single",
                                          value: _ctx.productStore.contractsForProduct,
                                          onRowSelect: _ctx.onContractSelected
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Column, {
                                              class: "text-lg-center",
                                              "selection-mode": "single",
                                              style: {"width":"5%","padding":"1rem","overflow":"hidden"}
                                            }),
                                            _createVNode(_component_Column, {
                                              key: "contractNumber",
                                              field: "contractNumber",
                                              header: _ctx.$t('contract.contractNumber')
                                            }, {
                                              body: _withCtx((item) => [
                                                (_ctx.userProfile?.isCadacSales || _ctx.userProfile?.isImpersonated)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_46, [
                                                      _createElementVNode("a", {
                                                        href: "javascript:void(0)",
                                                        title: _ctx.$t('common.goToCrm'),
                                                        onClick: ($event: any) => (_ctx.openUrl(item.data.crmUrl, '_blank'))
                                                      }, _toDisplayString(item.data.contractNumber), 9, _hoisted_47)
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(item.data.contractNumber), 1))
                                              ]),
                                              _: 1
                                            }, 8, ["header"]),
                                            _createVNode(_component_Column, {
                                              key: "endDate",
                                              field: "endDate",
                                              header: _ctx.$t('contract.endDate')
                                            }, {
                                              body: _withCtx((item) => [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(item.data.endDate)), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["header"]),
                                            _createVNode(_component_Column, {
                                              key: "remainingTerm",
                                              header: _ctx.$t('contract.remainingDuration')
                                            }, {
                                              body: _withCtx((item) => [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$tc("common.months", item.data.duration)), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["header"]),
                                            _createVNode(_component_Column, {
                                              header: `${_ctx.$t('common.costs')} ${_ctx.$t('common.pricePerMonth')}`
                                            }, {
                                              body: _withCtx((item) => [
                                                _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.formatCurrency(item.data.customerPrice)), 1)
                                              ]),
                                              _: 1
                                            }, 8, ["header"])
                                          ]),
                                          _: 1
                                        }, 8, ["selection", "value", "onRowSelect"])),
                                    (_ctx.productStore.canAddToContract)
                                      ? (_openBlock(), _createBlock(_component_Button, {
                                          key: 2,
                                          class: "py-0 mt-2 p-button-text p-button-link",
                                          label: _ctx.$t('product.button.dontAddToExistingContract'),
                                          onClick: _ctx.toggleAddToContract
                                        }, null, 8, ["label", "onClick"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : (!_ctx.isFlexLicense)
                                ? (_openBlock(), _createBlock(_component_ProductConfigurationStep, {
                                    key: 4,
                                    id: "step-duration"
                                  }, {
                                    header: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t("product.lblChooseDuration")), 1),
                                      (_ctx.vm.helpBlockDuration)
                                        ? (_openBlock(), _createBlock(_component_Button, {
                                            key: 0,
                                            class: "header-explanation-text text-underline py-0 p-button-text p-button-secondary",
                                            label: _ctx.vm.helpBlockDuration?.linkText,
                                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showHelpSideBar(_ctx.vm.helpBlockDuration)))
                                          }, null, 8, ["label"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    error: _withCtx(() => [
                                      (
											!_ctx.productValidation.get(_ctx.productValidationEnum.ValidContract) &&
											_ctx.submitted
										)
                                        ? (_openBlock(), _createBlock(_component_Message, {
                                            key: 0,
                                            id: `validation-msg-${_ctx.productValidationEnum.ValidContract}`,
                                            closable: false,
                                            severity: "error"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t("product.message.atleastOneAsset")), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["id"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    options: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productStore.availableDurations, (option, index) => {
                                        return (_openBlock(), _createBlock(_component_ProductConfigurationOption, {
                                          key: index,
                                          disabled: _ctx.isBusy,
                                          "is-selected": option.value === _ctx.productStore.selectedDuration,
                                          option: option,
                                          onOptionSelected: ($event: any) => (_ctx.onDurationSelected(option.value))
                                        }, {
                                          "usp-pricePerMonth": _withCtx(() => [
                                            _createElementVNode("span", {
                                              class: _normalizeClass({ 'text-muted': !_ctx.isCheapestDuration(option.value) })
                                            }, _toDisplayString(_ctx.$t("common.pricePerMonth", [
														_ctx.formatCurrency(_ctx.getPricePerMonthForDuration(option.value)),
													])), 3)
                                          ]),
                                          "usp-cheapest": _withCtx(() => [
                                            (_ctx.isCheapestDuration(option.value))
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                                                  _hoisted_52,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("product.bestPrice")), 1)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled", "is-selected", "option", "onOptionSelected"]))
                                      }), 128))
                                    ]),
                                    default: _withCtx(() => [
                                      (!_ctx.layoutStore.isAuthenticated && !_ctx.productStore.canAddToContract)
                                        ? (_openBlock(), _createBlock(_component_Message, {
                                            key: 0,
                                            closable: false,
                                            severity: "custom"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_i18n_t, { keypath: "product.message.loginToAddToContract" }, {
                                                loginLink: _withCtx(() => [
                                                  _createElementVNode("a", { href: _ctx.loginPageUrl }, _toDisplayString(_ctx.$t("common.login")), 9, _hoisted_53)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (_ctx.productStore.canAddToContract)
                                        ? (_openBlock(), _createBlock(_component_Button, {
                                            key: 1,
                                            class: "py-0 mt-2 p-button-text p-button-link",
                                            label: _ctx.$t('product.button.addToExistingContract'),
                                            onClick: _ctx.toggleAddToContract
                                          }, null, 8, ["label", "onClick"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_Message, {
                          key: 2,
                          closable: false,
                          severity: "error"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("product.message.currentlyUnavailable")), 1)
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                (_ctx.vm.relatedUpSellProducts?.length)
                  ? (_openBlock(), _createBlock(_component_ProductPageContentSection, {
                      key: 0,
                      type: "upsell"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_54, _toDisplayString(_ctx.$t("product.titleUpSell")), 1),
                        _createElementVNode("div", _hoisted_55, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vm.relatedUpSellProducts, (product) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: product,
                              class: "col-md-6 mb-2"
                            }, [
                              _createVNode(_component_BaseProductOverviewItemCard, {
                                "is-cross-sell": "",
                                vm: product
                              }, null, 8, ["vm"])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              tabInfo: _withCtx(() => [
                (_ctx.hasTab('tabInfo'))
                  ? (_openBlock(), _createBlock(_component_ProductPageContentSection, { key: 0 }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.vm.productInfoTabTitle || _ctx.$t("product.tabProductInfoTitle")) + " " + _toDisplayString(_ctx.vm.name), 1),
                        _createElementVNode("div", {
                          class: "rte",
                          innerHTML: _ctx.vm.productInfoTab
                        }, null, 8, _hoisted_56)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.$slots.blocks)
                  ? (_openBlock(), _createBlock(_component_ProductPageContentSection, {
                      key: 1,
                      type: "content"
                    }, {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "blocks", {}, undefined, true)
                      ]),
                      _: 3
                    }))
                  : _createCommentVNode("", true)
              ]),
              tabSpecifications: _withCtx(() => [
                (_ctx.hasTab('tabSpecifications'))
                  ? (_openBlock(), _createBlock(_component_ProductPageContentSection, {
                      key: 0,
                      type: "content"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.vm.specificationsTabTitle || _ctx.$t("product.tabSpecificationsTitle")) + " " + _toDisplayString(_ctx.vm.name), 1),
                        _createElementVNode("div", {
                          class: "product-specification",
                          innerHTML: _ctx.vm.specificationsTab
                        }, null, 8, _hoisted_57)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              tabContent: _withCtx(() => [
                (_ctx.hasTab('tabContent'))
                  ? (_openBlock(), _createBlock(_component_ProductPageContentSection, {
                      key: 0,
                      type: "content"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("product.tabContentTitle")) + " " + _toDisplayString(_ctx.vm.name), 1),
                        _createElementVNode("div", {
                          class: "",
                          innerHTML: _ctx.contentTabVm
                        }, null, 8, _hoisted_58)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              tabMedia: _withCtx(() => [
                (_ctx.hasTab('tabMedia'))
                  ? (_openBlock(), _createBlock(_component_ProductPageContentSection, {
                      key: 0,
                      type: "media"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.mediaEmbedCaption), 1),
                        _createElementVNode("embed", {
                          height: "100%",
                          src: _ctx.mediaEmbedSrc,
                          style: {"min-height":"400px"},
                          title: _ctx.mediaEmbedCaption,
                          type: "video/mp4",
                          width: "100%",
                          wmode: "transparent"
                        }, null, 8, _hoisted_59)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 3
            }, 8, ["items"])
          ]),
          summary: _withCtx(() => [
            _createVNode(_component_ProductPageSummary, {
              "can-submit": !_ctx.submitted && _ctx.validateProductConfiguration() && _ctx.vm.availableInCurrentMarket,
              "is-in-edit-mode": _ctx.isInEditMode,
              "is-autodesk-product": _ctx.isAutodeskProduct,
              "is-product-available": _ctx.vm.viewModelIsValid && !_ctx.isFlexLicense,
              "max-amount": _ctx.productStore.selectedVariation?.maxQuantity,
              "min-amount": _ctx.productStore.selectedVariation?.minQuantity,
              "offer-request-form-url": _ctx.vm.productGuid,
              "show-amount-input": "",
              "total-price": _ctx.priceSummary?.totalPrice,
              value: _ctx.productStore?.selectedAmount,
              "variation-guid": _ctx.productStore.selectedVariation?.guid,
              "variation-id": _ctx.productStore.selectedVariation?.id,
              onAddToCart: _ctx.addProductToCart,
              onAmountChanged: _ctx.onSelectedAmountChanged,
              onRequestAutodeskQuote: _ctx.onRequestAutodeskQuote
            }, {
              priceSummary: _withCtx(() => [
                _createVNode(_component_PriceSummary, { vm: _ctx.priceSummary }, null, 8, ["vm"]),
                _createElementVNode("p", _hoisted_60, _toDisplayString(_ctx.$t("common.productSummary.allPricesExclVat")), 1)
              ]),
              configurationSummary: _withCtx(() => [
                _createVNode(_component_ProductConfigurationSummary, {
                  header: _ctx.$t('product.titleSummaryProductSubscription', [_ctx.vm.name])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ProductConfigurationSummaryItem, {
                      content: _ctx.$t(`enum.licenseClass.${_ctx.productStore.selectedLicenseClass || 0}`),
                      label: _ctx.$t('product.lblLicenceType')
                    }, null, 8, ["content", "label"]),
                    (_ctx.vm.unitSelectionTitle && _ctx.productStore.selectedLicenseSize)
                      ? (_openBlock(), _createBlock(_component_ProductConfigurationSummaryItem, {
                          key: 0,
                          content: _ctx.productStore.selectedLicenseSizeLabel,
                          label: _ctx.vm.unitSelectionTitle
                        }, null, 8, ["content", "label"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ProductConfigurationSummaryItem, {
                      content: _ctx.$tc(`common.months`, _ctx.productStore.selectedDuration),
                      label: _ctx.$t('product.lblDuration')
                    }, null, 8, ["content", "label"]),
                    (_ctx.layoutStore.canImpersonate)
                      ? (_openBlock(), _createBlock(_component_ProductConfigurationSummaryItem, {
                          key: 1,
                          content: _ctx.productStore.selectedVariation?.sku,
                          label: "SKU"
                        }, null, 8, ["content"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["header"]),
                (_ctx.vm.currentPartner)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.$t("product.lblYourPartner")), 1),
                      _createVNode(_component_Button, {
                        class: "p-button-text p-button-arrow btn-partner-info",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showPartnerInfo = true))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_63, [
                            _createVNode(_component_Avatar, {
                              shape: "circle",
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.vm.currentPartner?.iconUrl)
                                  ? _withDirectives((_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      alt: _ctx.vm.currentPartner?.iconAlt,
                                      title: _ctx.vm.currentPartner?.name
                                    }, null, 8, _hoisted_64)), [
                                      [_directive_lazy, _ctx.vm.currentPartner?.iconUrl]
                                    ])
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.vm.currentPartner?.name), 1),
                            _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.vm.currentPartner?.addressString), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              validationMessage: _withCtx(() => [
                (_ctx.validationErrors.length && _ctx.submitted)
                  ? (_openBlock(), _createBlock(_component_Message, {
                      key: 0,
                      closable: false,
                      severity: "warn",
                      style: {"cursor":"pointer"},
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.scrollToFirstValidationError()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$tc("common.productSummary.msgValidationErrors", _ctx.validationErrors.length)), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              walletMessage: _withCtx(() => [
                _withDirectives(_createVNode(_component_WalletMessage, {
                  "wallet-amount": _ctx.productStore.walletAmount
                }, null, 8, ["wallet-amount"]), [
                  [_vShow, !_ctx.isSmallScreen && _ctx.vm?.canUseWallet && parseInt(_ctx.productStore.walletAmount) !== 0]
                ])
              ]),
              _: 1
            }, 8, ["can-submit", "is-in-edit-mode", "is-autodesk-product", "is-product-available", "max-amount", "min-amount", "offer-request-form-url", "total-price", "value", "variation-guid", "variation-id", "onAddToCart", "onAmountChanged", "onRequestAutodeskQuote"])
          ]),
          _: 3
        }, 8, ["modelValue", "help-block", "vm"]))
      : _createCommentVNode("", true),
    (_ctx.cartStore.showProductAddedModal)
      ? (_openBlock(), _createBlock(_component_ProductAddedModal, {
          key: 2,
          vm: _ctx.productAddedVm
        }, null, 8, ["vm"]))
      : _createCommentVNode("", true),
    (_ctx.showPartnerInfo)
      ? (_openBlock(), _createBlock(_component_PartnerInfoModal, {
          key: 3,
          vm: _ctx.vm.currentPartner,
          onCancel: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showPartnerInfo = false))
        }, null, 8, ["vm"]))
      : _createCommentVNode("", true)
  ], 64))
}